import { TimePickerComponent } from './../time-picker/time-picker.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { StopwatchComponent } from './stopwatch.component';
import { QrGeneratorComponentModule } from '../../../_shared/components/qr-generator/qr-generator.module';
@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        QrGeneratorComponentModule,
        TimePickerComponent
    ],
    declarations: [
        StopwatchComponent,
    ],
    exports: [StopwatchComponent]
})
export class StopwatchModule { }
